import { render, staticRenderFns } from "./invoice-phone.vue?vue&type=template&id=aa5ddae8"
import script from "./invoice-phone.vue?vue&type=script&lang=js"
export * from "./invoice-phone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports